import { render, staticRenderFns } from "./waitConfirm.vue?vue&type=template&id=c78940bc&"
import script from "./waitConfirm.vue?vue&type=script&lang=js&"
export * from "./waitConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports